import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import "./assets/css/tailwind.output.css";
import App from "./App";
import { SidebarProvider } from "./context/SidebarContext";
import { ThemeProvider } from "./context/ThemeContext";
import ThemedSuspense from "./components/ThemedSuspense";

// if (process.env.NODE_ENV !== 'production') {
//   const axe = require('react-axe')
//   axe(React, ReactDOM, 1000)
// }

const container = document.getElementById("root");
const root = createRoot(container);

const renderApp = () =>
  root.render(
    <React.StrictMode>
      <SidebarProvider>
        <ThemeProvider>
          <Suspense fallback={<ThemedSuspense />}>
            <App />
          </Suspense>
        </ThemeProvider>
      </SidebarProvider>
    </React.StrictMode>,
  );

// Prerendered pages ship real markup inside #root. createRoot replaces it (we
// deliberately do not hydrate: live data and Turnstile would mismatch), so load
// the route's lazy chunk first to avoid flashing the Suspense fallback.
const preloaders = {
  "/": () => import("./pages/LandingPage"),
  "/privacy": () => import("./pages/PrivacyPolicy"),
  "/termsofservice": () => import("./pages/TermsOfService"),
};
const preload =
  container.hasChildNodes() &&
  preloaders[window.location.pathname.replace(/\/+$/, "") || "/"];
if (preload) {
  preload()
    .catch(() => {})
    .then(renderApp);
} else {
  renderApp();
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register()
